import { render } from "./AllDoneModal.vue?vue&type=template&id=cad15778"
import script from "./AllDoneModal.vue?vue&type=script&lang=js"
export * from "./AllDoneModal.vue?vue&type=script&lang=js"
script.render = render

export default script